import api from './api';
import type {
  RepasseExtratoClinicaDTO,
  RepasseDocumentoDTO,
  RepasseDocumentoTipoContract,
  SubmeterAuditoriaResponseDTO,
} from '@sstexames/shared-types';

export const repassesService = {
  async obterMinhaApuracao(competencia?: string): Promise<RepasseExtratoClinicaDTO> {
    const params = competencia ? { competencia } : {};
    const res = await api.get<RepasseExtratoClinicaDTO>('/repasses/minha-apuracao', { params });
    return res.data;
  },

  async listarCompetencias(): Promise<Array<{ id: number; competencia: string; status: string }>> {
    const res = await api.get('/repasses/competencias');
    return res.data;
  },

  async uploadDocumento(
    competenciaId: number,
    tipoDocumento: RepasseDocumentoTipoContract,
    file: File,
  ): Promise<RepasseDocumentoDTO> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('competenciaId', String(competenciaId));
    formData.append('tipoDocumento', tipoDocumento);

    const res = await api.post<RepasseDocumentoDTO>(
      '/repasses/upload-documento',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return res.data;
  },

  async registrarNoShow(
    itemApuracaoId: number,
    motivo?: string,
  ): Promise<{ success: boolean; message?: string }> {
    const res = await api.post<{ success: boolean; message?: string }>(
      '/repasses/no-show',
      {
        itemApuracaoId,
        motivo,
      },
    );
    return res.data;
  },

  async anexarResultado(
    itemApuracaoId: number,
    file: File,
  ): Promise<{ success: boolean; message?: string; url?: string }> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('itemApuracaoId', String(itemApuracaoId));

    const res = await api.post<{ success: boolean; message?: string; url?: string }>(
      '/repasses/anexar-resultado',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return res.data;
  },

  async submeterAuditoria(
    competenciaId: number,
  ): Promise<SubmeterAuditoriaResponseDTO> {
    const res = await api.post<SubmeterAuditoriaResponseDTO>(
      '/repasses/submeter-auditoria',
      { competenciaId },
    );
    return res.data;
  },
};
